import { Component, OnInit, OnDestroy } from '@angular/core';
import { PendingApprovalService } from './pending-approval-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService, ConfigService } from '@services';
import { MatDialog } from '@angular/material/dialog';
import { ErrorDialogComponent } from '@dialog/error-dialog/error-dialog.component';
import { CookieService } from 'ngx-cookie';

@Component({
	selector: 'app-pending-approval',
	standalone: false,
	templateUrl: './pending-approval.component.html',
	styleUrls: ['./pending-approval.component.scss'],
})
export class PendingApprovalComponent implements OnInit, OnDestroy {
	timer: any;
	questionnaireCompleted: boolean = false;
	onboardingScheduled: boolean = false;
	isApproved: boolean = false;
	loading: boolean = false;
	userId: string = '';
	isEULAAccepted = false;
	isCompanyLinked = false;
	private statusCheckInterval: any;
	queryParamsForQuestionnaire:string = ''
	queryParamsForScheduleCall:string  = ''

	baseQuestionnaireUrl: string = '';
  baseMeetingUrl: string = '';
	isMultiCompany: boolean = false;

	constructor(
		private approvalService: PendingApprovalService,
		private route: ActivatedRoute,
		private router: Router,
		private auth: AuthService,
		private matDialog:MatDialog,
		private config: ConfigService,
		private cookies :CookieService
	) {}

	ngOnInit() {
		this.userId = this.route.snapshot.params['userId'];
		this.fetchApprovalStatus(this.userId);

		this.fetchOnboardingLinks();
		this.statusCheckInterval = setInterval(() => {
			this.fetchApprovalStatus(this.userId);
		}, 30 *1000);
		this.auth.isMultiCompanyUser$
      .subscribe((state) => this.isMultiCompany = state);
		this.timer=setTimeout(() => this.config.setSideBarNode(0), 0);
	}

	private fetchApprovalStatus(userId) {
		this.loading = true;
		this.approvalService.fetchApprovalStatus(userId).subscribe({
			next: response => {
				this.questionnaireCompleted = response.isQuestionnaireComplete;
				this.onboardingScheduled = response.isCustomerSuccessCallScheduled;
				this.isApproved = response.isClientApproved;
				this.isEULAAccepted = response.isEULAAccepted;
				this.isCompanyLinked = response.isCompanyLinked;
				this.queryParamsForQuestionnaire = response.questionnaireQueryString
				this.queryParamsForScheduleCall = response.scheduleCallQueryString
				if (
					this.questionnaireCompleted &&
					this.onboardingScheduled &&
					this.isApproved &&
					this.isEULAAccepted
				) {
					this.auth.getProfile().subscribe(data => {
						// this.auth.setCookieOrganisationId(data.Organization_ID);
						// this.auth.setApprovedMissingStatus(false);
						const cookie = this.auth.getFullCookie();
						if (cookie && cookie.user) {
								cookie.user.User_Code = 1;
								this.cookies.put('pippinTitleUsr', JSON.stringify(cookie));
						}
						this.router.navigate(['orders/current']);
					});
				}
				// else this.auth.setApprovedMissingStatus(true);
			},
			error: error => {
				// Handle error appropriately (show error message to user)
			},
			complete: () => {
				this.loading = false;
			},
		});
	}

	completeQuestionnaire(event: Event) {
		if (!this.isCompanyLinked) {
			event.preventDefault();
			event.stopPropagation();
			this.openErrorPopup('Company is not linked yet by the administrator.');
			return;
		}
		if (!this.baseQuestionnaireUrl) {
			event.preventDefault(); 
			this.openErrorPopup('Questionnaire link is not configured.');
			return;
		}
	}

	scheduleOnboarding(event: Event) {
		if (!this.isCompanyLinked) {
			event.preventDefault();
			event.stopPropagation();
			this.openErrorPopup('Company is not linked yet by the administrator.');
			return;
		}
		if (!this.baseMeetingUrl) {
			event.preventDefault();
			this.openErrorPopup('Meeting link is not configured.');
			return;
		}
	}

	onClickGo() {
		if (
			this.questionnaireCompleted &&
			this.onboardingScheduled &&
			this.isApproved &&
			this.isEULAAccepted
		) {
			this.router.navigate(['orders/current']).then();
			return;
		} else if (
			this.questionnaireCompleted &&
			this.onboardingScheduled &&
			this.isApproved &&
			!this.isEULAAccepted
		) {
			this.router.navigate(['termsandconditions/' + this.userId]).then();
		}
	}

	ngOnDestroy(): void {
		if (this.statusCheckInterval) {
			clearInterval(this.statusCheckInterval);
		}

		if(this.timer){
      clearTimeout(this.timer)
    };
	}

	get questionnaireUrl(): string {
    if (!this.baseQuestionnaireUrl) return '';
    return this.baseQuestionnaireUrl + (this.queryParamsForQuestionnaire || '');
  }

  get meetingUrl(): string {
    if (!this.baseMeetingUrl) return '';
    return this.baseMeetingUrl + (this.queryParamsForScheduleCall || '');
  }

	fetchOnboardingLinks(): void {
    this.approvalService.fetchOnboardingLinks().subscribe({
      next: (config) => {
        this.baseQuestionnaireUrl = config.questionnaireLink;
        this.baseMeetingUrl = config.scheduleCallLink;
      },
      error: (err) => {
				console.error('Failed to load onboarding links:', err);
				this.baseQuestionnaireUrl = '';
				this.baseMeetingUrl = '';
      }
    });
  }

	openErrorPopup(msg: string) {
		let dialogRef=this.matDialog.open(ErrorDialogComponent,{
			data:{
				message: msg
			}
		});
	}

	swithAccount = () => {
		this.router.navigate(['/accounts']);
	};
}
